<template lang="html">
  <div id="routeplan-overview-box" class="row">
    <div id="routeplan-destinations" class="col-12 no-pad-both">
      <div id="routeplan-edit-btn" class="text-center" @click="$emit('editRoute');" tabindex="0">
        <span class="material-icons" aria-hidden="true">edit</span>
        <span>Rediger</span>
      </div>

      <div id="routeplan-destinations-text" class="text-center">
        {{ routeDestinationValues }}
      </div>

      <div id="routeplan-details-btn" class="text-center" @click="$emit('showRouteDetails');" tabindex="0">
        <span class="material-icons" aria-hidden="true">list</span>
        <span>Detaljer</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routeDestinationValues: ''
    }
  },
  props: {
    showRouteOverview: {
      type: Boolean,
      required: true,
    }
  },
  watch: {
    showRouteOverview() {
      this.setRouteDestinationValues();
    },
  },
  methods: {
    setRouteDestinationValues: function() {
  		const startValue = document.getElementById('start-point-input').value;
      const endValue = document.getElementById('end-point-input').value;

  		const startString = isNaN(startValue) ? startValue : startValue.split(',')[0];
  		const endString = isNaN(endValue) ? endValue : endValue.split(',')[0];
  

  		let destinationValues = 'Fra '+startString+' til '+endString;
      if(document.getElementById('via-point-input').value != '') {
        const viaValue = document.getElementById('via-point-input').value;
        const viaString = isNaN(viaValue) ? viaValue : viaValue.split(',')[0];
        destinationValues += ' via '+viaString;
      }

  		var int = this.$HelperFunctions.isMobile ? 55 : 75;
  		if(destinationValues.length >= int) {
  			document.getElementById('routeplan-destinations-text').classList.add('double-line');
  		}
  		else {
  			document.getElementById('routeplan-destinations-text').classList.remove('double-line');
  		}
      this.routeDestinationValues = destinationValues;
  	},
  },
}
</script>

<style lang="css" scoped>
  #routeplan-overview-box {
    position: relative;
    height: auto;
  }

  #routeplan-destinations {
    position: relative;
    height: 50px;
  }

  #routeplan-destinations-text {
    position: absolute;
    left: 45px;
    height: 100%;
    width: calc(100% - 90px);
    line-height: 50px;
    vertical-align: middle;
    font-size: 12px;
  }


  #routeplan-destinations-text.double-line {
    line-height: 25px;
  }

  @media screen and (min-width: 767px) {
    #routeplan-destinations-text {
      font-size: 15px;
    }
  }

  #routeplan-edit-btn, #routeplan-details-btn {
    position: absolute;
    top: 0px;
    height: 100%;
    width: 45px;
    text-shadow: 1px 1px #eee;
    cursor: pointer;
  }

  #routeplan-edit-btn {
    left: 0px;
  }

  #routeplan-details-btn {
    right: 0px;
  }

  #routeplan-edit-btn span, #routeplan-details-btn span {
    position: relative;
    top: 30px;
    font-size: 12px;
  }

  #routeplan-edit-btn .material-icons, #routeplan-details-btn .material-icons {
    position: absolute;
    top: 5px;
    right: 10px;
    font-size: 25px !important;
  }

  @media screen and (min-width: 767px) {
    #routeplan-edit-btn {
      left: 10px;
    }

    #routeplan-details-btn {
      right: 10px;
    }
  }
</style>
